import { Col, Row, Form, Input, Button, Divider, Tag, Select } from 'antd';
import { DeleteOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { validateFileList } from 'utils/form/validators';
import { Upload, Accordion, AddButton } from 'components';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { ESTADOS } from 'constants/nombresCatalogos';
import { useSelector } from 'react-redux';
import './ServidoresPublicosJuntaLocal.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';

const getJuntasLocales = (idEstado, listEstados) => {
  const listJuntas = idEstado ? listEstados.find((e) => e.idEstado === idEstado)?.juntas : [];
  return listJuntas;
};

const ServidoresPublicosJuntaLocal = ({ form, loadingImages }) => {
  const estadosCat = useSelector(selectCatalogByName(ESTADOS));

  const formComponent = ({ remove, field, index }) => (
    <div key={index}>
      <div className="servidoresPublicosJuntaLocal">
        <Row gutter={24}>
          <Col span={13} className="servidoresPublicosJuntaLocal-tabla-header">
            <span className="requerido">*</span>Información del Servidor Público:
          </Col>
          <Col
            span={3}
            style={{ textAlign: 'center' }}
            className="servidoresPublicosJuntaLocal-tabla-header">
            <span className="requerido">*</span>Identificación anverso:
          </Col>
          <Col
            span={3}
            style={{ textAlign: 'center' }}
            className="servidoresPublicosJuntaLocal-tabla-header">
            <span className="requerido">*</span>Identificación reverso:
          </Col>
          <Col
            span={3}
            style={{ textAlign: 'center' }}
            className="servidoresPublicosJuntaLocal-tabla-header">
            <span className="requerido">*</span>Firma digital:
          </Col>
          <Col
            span={2}
            style={{ textAlign: 'center' }}
            className="servidoresPublicosJuntaLocal-tabla-header">
            Acciones
          </Col>
        </Row>
        <div className="container-infoServidorPublicoJL">
          <div className="info-servidorPublicoJL">
            <div className="servidorPublicoJL-nombre">
              <Form.Item
                name={[field.name, 'numEmpleado']}
                label="Número de empleado:"
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <Input
                  key={index}
                  style={{
                    width: 200
                  }}
                  maxLength={100}
                  placeholder="Escribe"
                />
              </Form.Item>
              <Form.Item
                name={[field.name, 'nombre']}
                label="Nombre(s):"
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <Input
                  key={index}
                  style={{
                    width: 300
                  }}
                  maxLength={100}
                  placeholder="Escribe"
                />
              </Form.Item>
              <Form.Item
                className=""
                name={[field.name, 'apPaterno']}
                label="Primer apellido:"
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <Input
                  key={index}
                  style={{
                    width: 200
                  }}
                  maxLength={50}
                  placeholder="Escribe"
                />
              </Form.Item>
            </div>
            <div className="servidorPublicoJL-puesto">
              <Form.Item name={[field.name, 'apMaterno']} label="Segundo apellido:">
                <Input
                  key={index}
                  style={{
                    width: 200
                  }}
                  maxLength={50}
                  placeholder="Escribe"
                />
              </Form.Item>
              <Form.Item
                name={[field.name, 'puesto']}
                label="Puesto:"
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <Input
                  key={index}
                  style={{
                    width: 200
                  }}
                  maxLength={50}
                  placeholder="Escribe"
                />
              </Form.Item>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, curValues) =>
                  prevValues.estadoId !== curValues.estadoId
                }>
                {() => {
                  const edoId = form.getFieldValue('estadoId');
                  let listJuntas = [];
                  if (edoId !== undefined) {
                    listJuntas = getJuntasLocales(edoId, estadosCat);
                  }
                  return (
                    <Form.Item
                      name={[field.name, 'numeroJuntaLC']}
                      label="Número de la Junta Local:"
                      rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                      <Select
                        key={index}
                        style={{
                          width: 300
                        }}
                        placeholder="Selecciona"
                        options={listJuntas}
                        fieldNames={{ value: 'idDistritoFed', label: 'nombreJunta' }}
                        filterOption={(inputValue, option) =>
                          option.nombreJunta?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                        }
                        showSearch
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </div>
          </div>
          <div className="container-imagenes">
            <Form.Item
              required
              name={[field.name, 'identAnverso']}
              className="hallazgos-imagenes-muestra"
              rules={[
                {
                  validator: validateFileList
                }
              ]}>
              <Upload
                className="actaInicioIdentAnversoSPJL"
                key={index}
                loading={loadingImages}
                aceptaVideo={false}
              />
            </Form.Item>
            <Form.Item
              required
              name={[field.name, 'identReverso']}
              className="hallazgos-imagenes-muestra"
              rules={[
                {
                  validator: validateFileList
                }
              ]}>
              <Upload
                className="actaInicioIdentReversoSPJL"
                key={index}
                loading={loadingImages}
                aceptaVideo={false}
              />
            </Form.Item>
            <Form.Item
              required
              name={[field.name, 'firma']}
              className="hallazgos-imagenes-muestra"
              rules={[
                {
                  validator: validateFileList
                }
              ]}>
              <Upload
                className="actaInicioFirmaSPJL"
                key={index}
                loading={loadingImages}
                aceptaVideo={false}
              />
            </Form.Item>
            <div className="servidoresublicosJL-imagenes-acciones">
              <Button key={index} style={{ height: '2em' }}>
                <DeleteOutlined onClick={() => remove(index)} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="formulario-servidoresPublicos">
      <Row gutter={[24, 0]} className="row-formulario">
        <Col span={24} className="col-dos-instrucciones">
          <span className="instruction-span-purple" style={{ paddingLeft: '9px' }}>
            Agrega los registros necesarios.
          </span>
          <Tag
            className="instruction-span-pink"
            icon={<ExclamationCircleFilled style={{ fontSize: '10px' }} />}
            bordered={false}
            color="magenta"
            style={{ marginBottom: '6px', paddingLeft: '9px' }}>
            El registro de servidores públicos es opcional. Si realizas el registro completa todos
            los campos solicitados.
          </Tag>
        </Col>
      </Row>
      <Form form={form} layout="vertical">
        <Form.List name="juntaLocalDistrital" initialValue={[]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => {
                const servidorPublico = {
                  key: `Serv_Publico_${index}`,
                  label: `Servidor Público ${index + 1}`,
                  forceRender: true,
                  children: formComponent({
                    remove,
                    field,
                    index
                  })
                };
                return <Accordion items={[servidorPublico]} defaultActiveKey={['servidor_0']} />;
              })}
              <Divider />
              <div className="servidorPublicoJL-btn">
                <Form.Item>
                  <AddButton
                    onClick={() => {
                      add();
                    }}
                    style={{ marginRight: '2em' }}>
                    Agregar Nuevo
                  </AddButton>
                </Form.Item>
              </div>
            </>
          )}
        </Form.List>
      </Form>
    </div>
  );
};

export default ServidoresPublicosJuntaLocal;

ServidoresPublicosJuntaLocal.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func,
    getFieldValue: PropTypes.func
  }).isRequired,
  loadingImages: PropTypes.bool
};

ServidoresPublicosJuntaLocal.defaultProps = {
  loadingImages: false
};
